import { render, staticRenderFns } from "./HeaderPopover.vue?vue&type=template&id=399debff&lang=pug"
import script from "./HeaderPopover.vue?vue&type=script&lang=ts"
export * from "./HeaderPopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports